/**
 * Discrete state classes applied to sequence elements.
 */
export enum SequenceState {
  ACTIVE = "-active",
  ENTERING = "-entering",
  LEAVING = "-leaving",
  DISABLED = "-disabled",
}

/**
 * Event data for sequence transitions.
 */
export interface SequenceEventData {
  /** Slider identifier */
  slider: string;
  /** Current step index */
  step: number;
  /** Transition progress from 0 to 1 (optional, for manual scrubbing) */
  transitionProgress?: number;
  /** Direction of transition: 1 = forward, -1 = backward */
  direction?: 1 | -1;
  /** Custom duration for this transition in ms (overrides element's sequence-duration) */
  duration?: number;
  /** Skip animation and switch instantly */
  instant?: boolean;
}

/**
 * CSS custom property names for sequence.
 */
export const SequenceProgressVars = {
  /** Unified progress variable (0 to 1) */
  PROGRESS: "--sequence-progress",
  /** Direction of current transition (1 or -1) */
  DIRECTION: "--sequence-direction",
} as const;
